const lang = 'he';

export const createNotActivatedMessage = (adType) => {
    return {
        header: lang === 'he' ? 'מזל טוב' : 'Congratulations!',
        body: lang === 'he'
            ? `כמעט העלית את מודעת ה-Mugics הראשונה שלך, הוא יהיה בגלקסיית ה-Mugics מיד לאחר הפעלת חשבונך על ידי לחיצה על הקישור בתיבת הדואר שלך`
            : `You almost uploaded your first mugics ${adType === 'liveMusic' ? 'event': 'ad'}, It will be visible in the mugics galaxy
                    right after you activate your account by clicking the link in your mail box
                 `
    }
};

export const activateUserOnSignup = () => ({
    header: lang === 'he' ? 'ברוכים הבאים ל- MUGIC!' : 'Welcome to MUGICS! Universe',
    body: lang === 'he' ?
        'כמעט מוכנים! אנא הפעילו את חשבונכם באמצעות הקישור במייל (בדקו את הספאם שלכם אם הוא לא בתיבת הדואר הנכנס)'
        : 'You are almost ready! Please activate your account with the link in your email (Check your spam if its not in Inbox)'
});

export const activateUserFirst = () => {
    return {
        header: lang === 'he' ? 'רגע!' : 'Wait!',
        body: lang === 'he'
            ? 'עליך להפעיל את חשבונך לפני שממשיכים הלאה.\n' +
            '         נשלח קישור למייל'
            : `You must activate your account before moving on. 
        Use the link you got in your email`
    }
};

export const createActivatedMessage = () => {
    return {
        header: lang === 'he' ? 'מזל טוב' : 'Congratulations!',
        body: lang === 'he' ? 'החשבון שלך אומת!' : `Your account was verified!`
    }
};

export const createDeleteMessage = name => ({
    header: lang === 'he' ? 'למחוק את המודעה?' : 'Delete This AD?',
    body: lang === 'he' ? '?' + name + ` האם אתה בטוח שברצונך למחוק את` : `Are you sure you want to delete ${name} ad?`

});

export const createSuccessfulNewPaidPin = () => ({
    header: lang === 'he' ? 'מזל טוב' : 'Congratulations!',
    body: lang === 'he' ? 'המודעה החדשה שלך מוכנה' : 'Your new ad is all set'
});

export const createSuccessfulUpdatedPaidPin = () => ({
    header: lang === 'he' ? 'מזל טוב!' : 'Congratulations!',
    body: lang === 'he' ? 'עדכנת בהצלחה את המודעה שלך' : 'You successfully updated your ad'
});

export const createNoEnrollDuplicationMessage = () => ({
    header: lang === 'he' ? 'רגע' : 'Wait',
    body: lang === 'he' ? 'זאת התוכנית שלך כרגע' : 'You are already using this ad type'
});

export const contactMessageWasSent = () => ({
    header: lang === 'he' ? 'מהר!' : 'Hurray!',
    body: lang === 'he' ? 'קיבלנו את הודעתך ונחזור אליך בקרוב' : 'We got your message and going to get back to your shortly'
});

export const createWarningMsg = reasonStr => ({
    header: lang === 'he' ? 'אוי לא!' :  'Oh no!',
    body: lang === 'he' ? 'משהו השתבש אנא צרו איתנו קשר לקבלת עזרה' : `Something went wrong with ${reasonStr || 'this'}. Please contact us for help`
});





// WEBPACK FOOTER //
// ./src/Models/strings.js